// src/pages/Register.jsx
import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Register() {
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ name: "", email: "", password: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    register(formData.name, formData.email, formData.password);
    alert(t("register.success"));
    navigate("/login");
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>{t("register.title")}</h2>
        <form onSubmit={handleSubmit}>
          <input 
            type="text" 
            placeholder={t("register.name_placeholder")} 
            value={formData.name}
            onChange={e => setFormData({...formData, name: e.target.value})}
            required 
          />
          <input 
            type="email" 
            placeholder={t("register.email_placeholder")} 
            value={formData.email}
            onChange={e => setFormData({...formData, email: e.target.value})}
            required 
          />
          <input 
            type="password" 
            placeholder={t("register.password_placeholder")} 
            value={formData.password}
            onChange={e => setFormData({...formData, password: e.target.value})}
            required 
          />
          <button type="submit" className="auth-btn">
            {t("register.submit")}
          </button>
        </form>
        
        <p className="auth-footer">
          {t("register.already_member")}{' '}
          <Link to="/login">{t("register.login_link")}</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;